import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { MAX_NUM_TRAITS_FOR_MULTI_TRAIT_OFFERS } from "../../../../../../packages/wallet/src/flow/BottomSheetFlows/constants";
export function useTraitOfferValidation(traits, traitOffersEnabled) {
  const $ = _c(11);
  const t = useTranslations("useTraitOfferValidation");
  if (!traitOffersEnabled) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        isValid: false,
        shouldShowDisabled: false,
        disabledReason: undefined,
        isTraitOffer: false
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const hasTraitsSelected = traits.length > 0;
  let t0;
  if ($[1] !== traits) {
    t0 = traits.length > 0 && traits.length <= MAX_NUM_TRAITS_FOR_MULTI_TRAIT_OFFERS && traits.every(_temp);
    $[1] = traits;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const traitSelected = t0;
  let shouldShowDisabled = false;
  let disabledReason;
  if (hasTraitsSelected && traitOffersEnabled && !traitSelected) {
    shouldShowDisabled = true;
    if (traits.length > MAX_NUM_TRAITS_FOR_MULTI_TRAIT_OFFERS) {
      let t1;
      if ($[3] !== t) {
        t1 = t("tooManyTraits", {
          max: MAX_NUM_TRAITS_FOR_MULTI_TRAIT_OFFERS
        });
        $[3] = t;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      disabledReason = t1;
    } else {
      if (traits.some(_temp2)) {
        let t1;
        if ($[5] !== t) {
          t1 = t("multipleValuesPerTrait");
          $[5] = t;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        disabledReason = t1;
      }
    }
  }
  let t1;
  if ($[7] !== disabledReason || $[8] !== shouldShowDisabled || $[9] !== traitSelected) {
    t1 = {
      isValid: traitSelected,
      shouldShowDisabled,
      disabledReason,
      isTraitOffer: traitSelected
    };
    $[7] = disabledReason;
    $[8] = shouldShowDisabled;
    $[9] = traitSelected;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}
function _temp2(trait_0) {
  return trait_0.values.length > 1;
}
function _temp(trait) {
  return trait.values.length === 1;
}